import { generateEnumTranslations } from "@app/shared/enumTranslate/generateEnumTranslations";

export enum TrackingEnum {
    NotApplicable = 1,
    Inbound = 2,
    Outbound = 3
}

export const TrackingTranslations = generateEnumTranslations(TrackingEnum, 'createScreen.form.trackingValues');